import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { TieredAccountCell } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountCell/TieredAccountCell';
import { TieredAccountRow } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountRow/TieredAccountRow';
import { RouterLink } from 'src/components/RouterLink/RouterLink';

export interface ParentAccountsRowProps {
  name: string;
  parentId: string; // A parent account's id is the parent_id which is returned by the API
  childCount: number; // Child count and linked accounts are synonymous, they both mean the number of accounts linked to a parent
}

export const ParentAccountsRow: React.FC<ParentAccountsRowProps> = ({
  name,
  parentId,
  childCount,
}) => {
  const parentAccountHomeUrl = `/corporate/enterprise/parents/${parentId}/children`;

  return (
    <TieredAccountRow>
      <TieredAccountCell width={6}>
        <RouterLink href={parentAccountHomeUrl}>{name}</RouterLink>
      </TieredAccountCell>
      <TieredAccountCell width={6}>
        <Copy variant="body">{childCount}</Copy>
      </TieredAccountCell>
    </TieredAccountRow>
  );
};
